export default "__VITE_ASSET__BXGW07dn__"